

export enum RoomSideEnum {
	Back = "back",
	Left = "left",
	Right = "right",
	Bottom = "bottom",
	Top = "top"
}